import React, { useRef, useState } from 'react';

import { EditorComponents } from '@acheloisbiosoftware/absui.core';
import InputDefinition from './InputDefinition';
import InputIcon from '@mui/icons-material/Input';
import PropTypes from 'prop-types';
import { usePromise } from '@acheloisbiosoftware/absui.hooks';
import { useSlate } from 'slate-react';

const { ToolbarButton } = EditorComponents;

function InputButton(props) {
  const { borrowFocus, inMenu } = props;
  const editor = useSlate();
  const buttonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState('');
  const [inputType, setInputType] = useState('text');
  const [units, setUnits] = useState('');
  const { promiseRef, defer } = usePromise();

  const onClose = (exited) => {
    setOpen(false);
    promiseRef.current.resolve(() => {
      if (!exited) {
        editor.Variable.insertInput({ label, inputType, units });
      }
    });
    setLabel('');
    setUnits('');
  };

  const onOpen = () => {
    borrowFocus(() => defer());
    setOpen(true);
  };

  return (
    <>
      <ToolbarButton
        icon={InputIcon}
        label='Insert Input'
        onClick={onOpen}
        inMenu={inMenu}
        ref={buttonRef}
      />
      <InputDefinition
        anchorEl={buttonRef?.current}
        open={open}
        onClose={onClose}
        formState={{
          label,
          setLabel,
          inputType,
          setInputType,
          units,
          setUnits,
        }}
      />
    </>
  );
}

InputButton.propTypes = {
  borrowFocus: PropTypes.func.isRequired,
  inMenu: PropTypes.bool,
};

export default InputButton;
